import {Component, OnInit, AfterViewInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {ServicesService} from '../../services.service';
import {AppComponent} from '../../app.component';

declare var $: any;

@Component({
    selector: 'app-entrada-caminhoes',
    templateUrl: './entrada-caminhoes.component.html',
    styleUrls: ['./entrada-caminhoes.component.css'],
    providers: [
        ServicesService
    ]
})

export class EntradaCaminhoesComponent implements OnInit, AfterViewInit, OnDestroy {

    condutor: string;
    tabFila: any;
    veiculoInfo = {Tipo: '', CPF: '', Condutor: '', Celular: ''};
    veiculoPlaca = '';
    exibeAguarde: boolean = false;
    private dataTableInitialized: boolean = false;
    private isLoading: boolean = false;

    constructor(private _services: ServicesService, private _appcomponent: AppComponent) {}

    moveNextField(event: any, maxlength: number, nextfield: string) {
        const target = event.target || event.srcElement || event.currentTarget;
        if (target.value.length >= maxlength) {
            document.getElementsByName(nextfield)[0].focus();
        }
    }

    changeNextField(event: any, nextfield: string) {
        const target = event.target || event.srcElement || event.currentTarget;
        if (target.value.length > 0) {
            this.veiculoInfo.Tipo = target.value;
            document.getElementsByName(nextfield)[0].focus();
        }
    }

    changeUCName(event: any, campo: string) {
        const target = event.target || event.srcElement || event.currentTarget;
        if (target.value.length > 0) {
            const functions = this._services;
            this[campo] = functions.ucname(target.value);
            this.veiculoInfo.Condutor = this[campo];
        }
    }

    changeCelular(event: any) {
        const target = event.target || event.srcElement || event.currentTarget;
        if (target.value.length > 0) {
            this.veiculoInfo.Celular = target.value;
        }
    }

    changeUppercase(event: any, campo: string) {
        const target = event.target || event.srcElement || event.currentTarget;
        if (target.value.length > 0) {
            this[campo] = target.value.toUpperCase();
        }
    }

    getPlacaInfo(event: any) {
        const functions = this._services;
        const target = event.target || event.srcElement || event.currentTarget;
        if (target.value.length > 0) {
            this.exibeAguarde = true;
            this.veiculoPlaca = target.value.toUpperCase();
            const placa = {placa: target.value.toUpperCase()};
            functions.requestAPIData(placa, 'getDadosPlaca').then(
                reg => {
                    if (reg.sucesso) {
                        if (reg.dados.length > 0) {
                            this.veiculoInfo = reg.dados[0];
                        } else {
                            this.veiculoInfo = {Tipo: '', CPF: '', Condutor: '', Celular: ''};
                        }
                        this.exibeAguarde = false;
                    }
                }
            );
        }
    }

    getCondutorInfo(event: any) {
        const functions = this._services;
        const target = event.target || event.srcElement || event.currentTarget;
        if (target.value.length > 0) {
            this.exibeAguarde = true;
            this.veiculoInfo.CPF = target.value;
            const cpf = {cpf: target.value};
            functions.requestAPIData(cpf, 'getDadosCondutor').then(
                reg => {
                    if (reg.sucesso) {
                        if (reg.dados.length > 0) {
                            this.veiculoInfo.Condutor = reg.dados[0].Condutor;
                            this.veiculoInfo.Celular = reg.dados[0].Celular;
                        } else {
                            this.veiculoInfo.Condutor = '';
                            this.veiculoInfo.Celular = '';
                        }
                        this.exibeAguarde = false;
                    }
                }
            );
        }
    }

    verifyMandatoryFields(serializedArray: any, mandatoryFields: string[]) {
        let i: number;
        const r: any = {};
        r['status'] = true;
        for (i = 0; i < mandatoryFields.length; i++) {
            if (serializedArray[mandatoryFields[i]] === undefined || serializedArray[mandatoryFields[i]].length <= 0) {
                r['status'] = false;
                r['field'] = mandatoryFields[i];
                i = mandatoryFields.length;
            }
        }
        return r;
    }

    /**
     * Modal simples com Bootstrap
     */
    private mostrarMensagem(tipo: string, texto: string) {
        // Remove modais anteriores
        $('#simpleModal').remove();
        $('.modal-backdrop').remove();
        
        // Define cor e ícone baseado no tipo
        let corHeader = 'bg-primary';
        let icone = 'info-circle';
        
        if (tipo === 'success') {
            corHeader = 'bg-success';
            icone = 'check-circle';
        } else if (tipo === 'error') {
            corHeader = 'bg-danger';
            icone = 'exclamation-triangle';
        } else if (tipo === 'alert') {
            corHeader = 'bg-warning';
            icone = 'exclamation-circle';
        }
        
        // Cria o modal
        const modalHtml = `
            <div class="modal fade" id="simpleModal" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header ${corHeader} text-white">
                            <h5 class="modal-title">
                                <i class="fas fa-${icone} mr-2"></i>
                                ${tipo === 'success' ? 'Sucesso' : tipo === 'error' ? 'Erro' : 'Atenção'}
                            </h5>
                            <button type="button" class="close text-white" id="closeModalX">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p class="mb-0">${texto}</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" id="closeModalBtn">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        // Adiciona ao body
        $('body').append(modalHtml);
        
        // Mostra o modal
        const $modal = $('#simpleModal');
        $modal.addClass('show').css('display', 'block');
        $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');
        
        // Função para fechar o modal
        const fecharModal = () => {
            $modal.removeClass('show');
            $modal.css('display', 'none');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            
            setTimeout(() => {
                $modal.remove();
            }, 300);
        };
        
        // Event listeners para fechar
        $('#closeModalBtn').on('click', fecharModal);
        $('#closeModalX').on('click', fecharModal);
        
        // Fecha ao clicar fora
        $modal.on('click', function(e) {
            if (e.target === this) {
                fecharModal();
            }
        });
        
        // Fecha com ESC
        $(document).on('keydown.modal', function(e) {
            if (e.key === 'Escape') {
                fecharModal();
                $(document).off('keydown.modal');
            }
        });
    }

    addRegistro() {
        const functions = this._services;
        
        // Altera botão para aguarde
        functions.waitButton('#btnaddregistro', '<i class=\'fas fa-spinner fa-pulse\'></i>');
        $('.is-invalid').removeClass('is-invalid');
        $('.is-invalid-field').hide();
        
        const registro = functions.arraytoObj($('#addRegistro').serializeArray());
        $('#addRegistro input, #addRegistro select').attr('disabled', 'true');
        
        let chk: any;
        chk = this.verifyMandatoryFields(registro, ['placa', 'tipo', 'cpf', 'condutor', 'celular']);
        
        if (chk['status']) {
            functions.requestAPIData(registro, 'addRegistroFila').then(
                reg => {
                    if (reg.sucesso) {
                        this.listaFila();
                        // Limpa formulário
                        $('#addRegistro input, #addRegistro select').removeAttr('disabled');
                        this.veiculoInfo = {Tipo: '', CPF: '', Condutor: '', Celular: ''};
                        this.veiculoPlaca = '';
                        functions.returnButton('#btnaddregistro', 'OK');
                        
                        this.mostrarMensagem('success', 'Veículo adicionado à fila!');
                    } else {
                        $('#addRegistro input, #addRegistro select').removeAttr('disabled');
                        functions.returnButton('#btnaddregistro', 'OK');
                        
                        this.mostrarMensagem('error', 'Erro ao adicionar veículo: ' + (reg.mensagem || 'Erro desconhecido'));
                    }
                }
            ).catch(error => {
                $('#addRegistro input, #addRegistro select').removeAttr('disabled');
                functions.returnButton('#btnaddregistro', 'OK');
                
                this.mostrarMensagem('error', 'Erro na comunicação com o servidor');
            });
        } else {
            $('select[name=' + chk['field'] + '], input[name=' + chk['field'] + ']').addClass('is-invalid');
            $('.is-invalid-field').html('Campo \'' + chk['field'].toUpperCase() + '\' não preenchido.');
            $('.is-invalid-field').fadeIn('fast');
            $('#addRegistro input, #addRegistro select').removeAttr('disabled');
            functions.returnButton('#btnaddregistro', 'OK');
        }
    }

    private listaFila() {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;
        const functions = this._services;
        
        functions.listAPIData('listFilaPortaria').then(
            reg => {
                
                if (reg.sucesso) {
                    const dts = [];
                    for (let i = 0; i < reg.dados.length; i++) {
                        let iconStatus = '';
                        switch (reg.dados[i].Status) {
                            case 'ENTRADA REGISTRADA':
                                iconStatus = '<i class=\'fas fa-hourglass-start\' style=\'font-size: 1.1em; color: #ED1C24;\' title=\'Aguardando\'></i>';
                                break;
                            case 'DESCARREGANDO':
                                iconStatus = '<i class=\'fas fa-shipping-fast\' style=\'font-size: 1.1em; color: #218838;\' title=\'Descarregando\'></i>';
                                break;
                            case 'EM FILA':
                                iconStatus = '<i class=\'fas fa-hourglass-half\' style=\'font-size: 1.1em; color: #F58220;\' title=\'Aguardando Baia\'></i>';
                                break;
                            case 'LIBERADO':
                                iconStatus = '<button id=\'libfila_' + reg.dados[i].Id + '\' data-filaid=\'' + reg.dados[i].Id + '\' class=\'ml-1 btn btn-outline-dark-min liberaveiculo\' title=\'Liberar Saída\' type=\'button\'><i class=\'fas fa-shipping-fast\'></i></button>';
                                break;
                        }
                        
                        const dt = {
                            order: '<span style="font-weight: 500; color: #6c757d;">' + (i + 1) + '</span>', 
                            placa: '<span style="font-weight: 500; color: #6c757d;">' + reg.dados[i].Placa + '</span>', 
                            tipo: '<span style="font-weight: 500; color: #6c757d;">' + reg.dados[i].Tipo + '</span>', 
                            condutor: '<span style="font-weight: 500; color: #6c757d;">' + reg.dados[i].Condutor + '</span>', 
                            celular: '<span style="font-weight: 500; color: #6c757d;">' + reg.dados[i].Celular + '</span>', 
                            data: '<span style="font-weight: 500; color: #6c757d;">' + new Date(reg.dados[i].Entrada).toLocaleString() + '</span>', 
                            status: iconStatus
                        };
                        dts.push(dt);
                    }
                    
                    // Atualiza DataTable
                    if (this.dataTableInitialized && this.tabFila) {
                        this.tabFila.clear();
                        this.tabFila.rows.add(dts);
                        this.tabFila.draw();
                    } else {
                        setTimeout(() => {
                            if (this.dataTableInitialized && this.tabFila) {
                                this.tabFila.clear();
                                this.tabFila.rows.add(dts);
                                this.tabFila.draw();
                            }
                        }, 500);
                    }
                }
                
                this.isLoading = false;
            }
        ).catch(error => {
            this.isLoading = false;
        });
    }

    liberaVeiculo(filaId: string) {
        const functions = this._services;
        const $btn = $('#libfila_' + filaId);
        
        // Desabilita botão
        $btn.prop('disabled', true);
        functions.waitButton('#libfila_' + filaId, '<i class=\'fas fa-spinner fa-pulse\'></i>');
        
        const registro = {filaId: filaId};
        
        functions.requestAPIData(registro, 'liberarVeiculo').then(
            reg => {
                if (reg.success) {
                    this.listaFila();
                    this.mostrarMensagem('success', 'Saída do Veículo Registrada!');
                } else {
                    $btn.prop('disabled', false);
                    functions.returnButton('#libfila_' + filaId, '<i class=\'fas fa-shipping-fast\'></i>');
                    
                    this.mostrarMensagem('error', 'Erro ao liberar a saída: ' + reg.mensagem);
                }
            }
        ).catch(error => {
            $btn.prop('disabled', false);
            functions.returnButton('#libfila_' + filaId, '<i class=\'fas fa-shipping-fast\'></i>');
            
            this.mostrarMensagem('error', 'Erro na comunicação com o servidor');
        });
    }

    ngOnInit(): void {
        const Plataforma = this;
        this.listaFila();
        // Event handler para liberar veículo
        $('body').off('click', '.liberaveiculo').on('click', '.liberaveiculo', function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            const $btn = $(this);
            if ($btn.prop('disabled')) {
                return;
            }
            
            const filaId = $btn.data('filaid');
            Plataforma.liberaVeiculo(filaId);
        });
        
        // Máscaras
        $('input[name=placa]').mask('AAAAAAA');
        const SPMaskBehavior = function (val: any) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 0 0000-0000' : '(00) 0000-00009';
        },
        spOptions = {
            onKeyPress: function (val: any, e: any, field: any, options: any) {
                field.mask(SPMaskBehavior.apply({}, arguments), options);
            }
        };
        $('.telefone').mask(SPMaskBehavior, spOptions);
        $('.cpf').mask('000.000.000-00');
        
        // Select2
        $('.useSelect2noSearch').select2({
            theme: 'bootstrap',
            placeholder: 'Selecione...',
            width: '100%',
            display: 'block',
            selectOnClose: false,
            minimumResultsForSearch: -1,
            allowClear: true
        });
        $('.useSelect2').select2({
            theme: 'bootstrap',
            width: '100%',
            display: 'block',
            selectOnClose: false,
            placeholder: 'Selecione...',
            allowClear: true
        });
    }

    ngAfterViewInit(): void {
        const DataTableLanguage = {
            'sEmptyTable': 'Nenhum registro encontrado',
            'sInfo': 'Mostrando _START_ até _END_ de _TOTAL_ registros',
            'sInfoEmpty': 'Mostrando 0 até 0 de 0 registros',
            'sInfoFiltered': '(Filtrados de _MAX_ registros)',
            'sInfoPostFix': '',
            'sInfoThousands': '.',
            'sLengthMenu': '_MENU_ resultados por página',
            'sLoadingRecords': 'Carregando...',
            'sProcessing': 'Processando...',
            'sZeroRecords': 'Nenhum registro encontrado',
            'sSearch': '<i class="fas fa-search" aria-hidden="true"></i>',
            'oPaginate': {
                'sNext': '<i class="fa fa-step-forward" aria-hidden="true"></i>',
                'sPrevious': '<i class="fa fa-step-backward" aria-hidden="true"></i>',
                'sFirst': '<i class="fa fa-backward" aria-hidden="true"></i>',
                'sLast': '<i class="fa fa-forward" aria-hidden="true"></i>'
            },
            'oAria': {
                'sSortAscending': ': Ordenar colunas de forma ascendente',
                'sSortDescending': ': Ordenar colunas de forma descendente'
            }
        };

        setTimeout(() => {
            // Destruir instância existente se houver
            if ($.fn.DataTable.isDataTable('#tabFila')) {
                $('#tabFila').DataTable().destroy();
            }

            // Criando DataTable
            this.tabFila = $('#tabFila').DataTable({
                language: DataTableLanguage,
                lengthChange: false,
                pageLength: 5,
                info: true,
                paging: true,
                searching: true,
                ordering: true,
                responsive: true,
                autoWidth: false,
                bScrollCollapse: true,
                'columns': [
                    {data: 'order', className: 'text-center', 'orderable': true},
                    {data: 'placa', className: 'text-center', 'orderable': false},
                    {data: 'tipo', className: 'text-center', 'orderable': false},
                    {data: 'condutor', className: 'text-center', 'orderable': false},
                    {data: 'celular', className: 'text-center', 'orderable': false},
                    {data: 'data', className: 'text-center', 'orderable': false},
                    {data: 'status', className: 'text-center', 'orderable': false}
                ]
            });
            
            $('#tabFila th').removeClass('text-left');
            $('#tabFila_filter input[type=search]').attr('placeholder', 'Pesquisar');
            $('#tabFila_filter input[type=search]').addClass('form-control');
            $('#tabFila_filter i.fas.fa-search').remove();
            
            this.dataTableInitialized = true;
            
            this.listaFila();
        }, 100);
    }

    ngOnDestroy(): void {
        $('body').off('click', '.liberaveiculo');
        
        if (this.tabFila) {
            this.tabFila.destroy();
        }
    }
}